import React from 'react';
import { FeedbackWidget } from './FeedbackWidget';
import { feedbackConfig } from './feedbackConfig';

/**
 * FeedbackProvider - Wrapper for the FeedbackWidget
 * 
 * This component is used in the root App to provide the feedback
 * widget on every page. It wraps the FeedbackWidget with the app's configuration.
 */
export function FeedbackProvider() {
  return <FeedbackWidget config={feedbackConfig} />;
}

